<ng-container>
    <i *ngIf="!item.Archived" title="archive" (click)="toggleArchive($event)" class="fa fa-2x fa-fw fa-trash icon-main"></i>
    <i *ngIf="item.Archived" title="un-archive" (click)="toggleArchive($event)" class="fa fa-2x fa-fw fa-unlock icon-main"></i>
</ng-container>
